import { render, staticRenderFns } from "./ServiceSchedule.vue?vue&type=template&id=bbfba1ea&scoped=true&"
import script from "./ServiceSchedule.vue?vue&type=script&lang=js&"
export * from "./ServiceSchedule.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSchedule.vue?vue&type=style&index=0&id=bbfba1ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfba1ea",
  null
  
)

export default component.exports